module.exports = __webpack_public_path__ + "img/Layer-6.c5501665.webp";